const SoundStreamingChannels = {
    BACKGROUND_MUSIC: 0,
    VOICE_OVER: 1,
};

export default SoundStreamingChannels;